import { render, staticRenderFns } from "./SyncLicensesAlert.vue?vue&type=template&id=05fc6052&scoped=true"
import script from "./SyncLicensesAlert.vue?vue&type=script&lang=js"
export * from "./SyncLicensesAlert.vue?vue&type=script&lang=js"
import style0 from "./SyncLicensesAlert.vue?vue&type=style&index=0&id=05fc6052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc6052",
  null
  
)

export default component.exports